import React, { useState, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import Pagination from '../../../components/common/Pagination';
import optionsIcon from '../../../images/icon-vert-dots.svg';
import deleteIcon from '../../../images/icon-trash.svg';
import iconEye from '../../../images/icon-eye.svg';
import iconRefresh from '../../../images/refresh.png';

const RecycleBinTable = ({ handlePageChange, handleRestore, handleDelete, onUserSelect }) => {
  const { users, currentPage, totalPages } = useSelector((state) => state.admin_deleted_users);
  const [openDropdown, setOpenDropdown] = useState(null);
  const dropdownRef = useRef(null);
  
  const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });
  
  const toggleDropdown = (id, event) => {
    if (openDropdown === id) {
      setOpenDropdown(null);
    } else {
      const rect = event.target.getBoundingClientRect();
      setDropdownPosition({ top: rect.bottom, left: rect.left-100 });
      setOpenDropdown(id);
    }
  };
 
  const handleClickOutside = (event) => {
    const isDropdownToggle = event.target.closest('.dropdown-toggle');
    const isDropdownMenu = event.target.closest('.dropdown-menu');
    if (!isDropdownToggle && !isDropdownMenu) {
      setOpenDropdown(null);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

   const handleScroll = () => {
    setOpenDropdown(null);
  };

  useEffect(() => {
      window.addEventListener('scroll', handleScroll, true);
    return () => {
      window.removeEventListener('scroll', handleScroll, true);
    };
  }, []);

  return (
    <>
    <div className="table-responsive">
      <table className="table table-striped table-users table-alex printarea">
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>User Type</th>
            <th>Deleted By</th>
            <th>Deleted At</th>
            <th className="noprint">Manage</th>
          </tr>
        </thead>
        <tbody>
          {users && users.length > 0 ? (
            users.map((user) => (
              <tr key={user.id}>
                <td><div className="text-start">{user.first_name} {user.last_name}</div></td>
                <td>{user.email}</td>
                <td>{user.account_type}</td>
                <td>{user.deleted_by_name}</td>
                <td>{new Date(user.deleted_at).toLocaleString('en-US', { dateStyle: 'medium', timeStyle: 'short' })}</td>
                <td className="noprint">
                  <div className="text-center position-relative" ref={dropdownRef}>
                    <button 
                      type="button" 
                      className="bg-transparent border-0 p-0 dropdown-toggle btn-vert-dots" 
                      aria-expanded="false" 
                      onClick={(e) => toggleDropdown(user.id, e)}
                    >
                      <img src={optionsIcon} alt="Options" />
                    </button>
                    {openDropdown === user.id && (
                      <ul className="dropdown-menu dropdown-menu-end" 
                      style={{  display: 'block',
                            position: 'fixed',
                            top: `${dropdownPosition.top}px`,
                            left: `${dropdownPosition.left}px`,
                            width: `200px`,
                            zIndex: 1050, }}
                      >  
                        <li>
                          <a className="dropdown-item" onClick={() => handleRestore(user.id)}>
                            <img src={iconRefresh} alt="Restore" /> Restore
                          </a>
                        </li>
                        <li style={{display:'none'}}>
                          <a className="dropdown-item" onClick={() => handleDelete(user.id)}>
                            <img src={deleteIcon} alt="Delete" /> Delete Permanently
                          </a>
                        </li>

                        <li>
                        <a
                          className="dropdown-item"
                          onClick={() => {
                            onUserSelect(user.id);
                            toggleDropdown(user.id);
                          }}
                        >
                          <img src={iconEye} alt="View" /> View
                        </a>
                        </li>
                      </ul>
                    )}
                  </div>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="6" className="text-center">No deleted users found.</td>
            </tr>
          )}
        </tbody>
      </table>
      </div>
      <Pagination 
        currentPage={currentPage} 
        totalPages={totalPages} 
        onPageChange={handlePageChange} 
      />
    </>
  );
};

export default RecycleBinTable;